import React from 'react'
import { Box, Typography } from '@mui/material'
import RadioIcon from '@mui/icons-material/Radio'
import GraphicEqIcon from '@mui/icons-material/GraphicEq'
import { useNavigate } from 'react-router-dom'

const FloatingRadioNotice = () => {
    const navigate = useNavigate();
    const handleOpenRadio = () => {
        navigate('/radio-fenabocol');
    }

    return (
        <Box
            onClick={handleOpenRadio}
            sx={{
                position: 'fixed',
                right: { xs: 12, md: 20 },
                bottom: { xs: 12, md: 20 },
                zIndex: 1300,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 1,
                borderRadius: '14px',
                cursor: 'pointer',
                background: 'linear-gradient(135deg, #d32f2f 0%, #ff5252 100%)',
                color: '#fff',
                boxShadow: '0 8px 20px rgba(0,0,0,.22)',
                transition: 'transform .25s ease, box-shadow .25s ease',
                animation: 'radioFloat 2.2s ease-in-out infinite',
                maxWidth: 200,
                '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 12px 28px rgba(0,0,0,.3)',
                },
                '@keyframes radioFloat': {
                    '0%': { transform: 'translateY(0px)' },
                    '50%': { transform: 'translateY(-5px)' },
                    '100%': { transform: 'translateY(0px)' },
                },
            }}
        >
            <Box
                sx={{
                    width: 34,
                    height: 34,
                    minWidth: 34,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(255,255,255,.18)',
                    position: 'relative',
                }}
            >
                <RadioIcon sx={{ fontSize: 18 }} />
                <GraphicEqIcon
                    sx={{
                        position: 'absolute',
                        right: -5,
                        bottom: -2,
                        fontSize: 12,
                        color: '#ffe082',
                    }}
                />
            </Box>

            <Box sx={{ overflow: 'hidden' }}>
                <Typography
                    sx={{
                        fontSize: '0.65rem',
                        fontWeight: 700,
                        lineHeight: 1,
                        textTransform: 'uppercase',
                        opacity: 0.9,
                    }}
                >
                    En vivo
                </Typography>

                <Typography
                    sx={{
                        fontSize: '0.85rem',
                        fontWeight: 800,
                        lineHeight: 1.1,
                    }}
                >
                    Fenabocol Stereo
                </Typography>
            </Box>
        </Box>
    )
}

export default FloatingRadioNotice